import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=5283c338&scoped=true"
import script from "./shopDetail.vue?vue&type=script&lang=js"
export * from "./shopDetail.vue?vue&type=script&lang=js"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=5283c338&prod&lang=less&scoped=true"
import style1 from "./shopDetail.vue?vue&type=style&index=1&id=5283c338&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283c338",
  null
  
)

export default component.exports